import { IKeHoachNamActionTypes } from "../../action-types/ke-hoach/IKeHoachNamActions";
import { IKeHoachNamReducer } from "../../reducer-model/ke-hoach/IKeHoachNamReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IKeHoachNamReducer = {
  status: eReducerStatusBase.is_not_initialization,
  keHoachNams: [],
  selectedIds: []
};
export const keHoachNamReducer = (
  state: IKeHoachNamReducer = iniState,
  action: IKeHoachNamActionTypes
): IKeHoachNamReducer => {
  switch (action.type) {
    case "KE_HOACH_NAM_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "KE_HOACH_NAM_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        keHoachNams: action.payload,
      };
    case "KE_HOACH_NAM_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "KE_HOACH_NAM_SHOW_EDIT_MODAL":
      return {
        ...state,
        keHoachNamEditing: action.payload,
        isShowEditModal: true
      };
    case "KE_HOACH_NAM_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false
      };
    case "KE_HOACH_NAM_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      };
    case "KE_HOACH_NAM_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false
      };
    case "KE_HOACH_NAM_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      };
    case "KE_HOACH_NAM_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting
      };
    case "KE_HOACH_NAM_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload
      };
    case "KE_HOACH_NAM_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      };
    case "KE_HOACH_NAM_CHANGE_SELECTED_IDS":
      return {
        ...state,
        selectedIds: action.payload
      };
    default:
      return state;
  }
};
